import React from 'react'
import { lazy } from 'react'

const DashboardWrapper = lazy(() =>
  import('./components/DashboardWrapper').then(
    (module) => ({ default: module.DashboardWrapper })),
)
const CategoryPage = lazy(() => import('./CategoryPage'))
const CategoryDetailPage = lazy(() => import('./CategoryDetailPage'))
const HealthDetailPage = lazy(() => import('./HealthDetailPage'))
const ResultsPage = lazy(() => import('./ResultsPage'))
const ResultDetailPage = lazy(() => import('./ResultDetailPage'))
const ProfilePage = lazy(() => import('./ProfilePage'))
const AppointmentDetailPage = lazy(() => import('./AppointmentDetailPage'))

const DashboardRouting = [
  {
    element: (
      <DashboardWrapper
        element={<ProfilePage />}
        mobileTitle="modules:dashboard:Users:title"
        title=""
      />
    ),
    path: 'profile',
  },
  {
    element: (
      <DashboardWrapper
        element={<CategoryPage />}
        mobileTitle="modules:dashboard:Category:title"
        title=""
      />
    ),
    path: 'category',
  },
  {
    element: (
      <DashboardWrapper
        element={<CategoryDetailPage />}
        mobileTitle="modules:dashboard:HealthDetail:title"
        title=""
      />
    ),
    path: 'category/:shopifyID',
  },
  {
    element: (
      <DashboardWrapper
        element={<HealthDetailPage />}
        mobileTitle="modules:dashboard:Health:healthMetrics:title"
        title=""
      />
    ),
    path: 'health/:loincNum',
  },
  {
    element: (
      <DashboardWrapper
        element={<ResultsPage />}
        mobileTitle="modules:dashboard:Results:title"
        title=""
      />
    ),
    path: 'results',
  },
  {
    element: (
      <DashboardWrapper
        element={<ResultDetailPage />}
        mobileTitle=""
        title=""
        hideMobileHeader />
    ),
    path: 'results/:testUuid',
  },
  {
    element: (
      <DashboardWrapper
        element={<AppointmentDetailPage />}
        mobileTitle="modules:dashboard:Appointments:title"
        title=""
        hideMobileHeader />
    ),
    path: 'appointment/:testUuid',
  },
]

export default DashboardRouting
